export default {
    values: {
        'Showing: %n templates': [
            [0, 0, 'No template found'],
            [1, 1, 'Showing: 1 template'],
            [2, null, 'Showing: %n templates']
        ],
        properties: 'Properties',
        alias: 'Alias',
        color: 'Color',
        description: 'Description',
        category: 'Category',
        discard_changes: 'Discard changes',
        'form json': 'Form JSON',
        'new template': 'New Template',
        Rigs: 'Rigs',
        Wells: 'Wells',
        Crew: 'Crews',
        'Select a rig': 'Select a rig',
        'Select a well': 'Select a well',
        'Select a crew': 'Select a crew',
        'Select a template': 'Select a template',
        Templates: 'Templates'
    }
}
